<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Reporte Ordenes de Compra</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <div>
            Favor seleccione las fechas y las sucursales:

            <form
                class="form"
                [formGroup]="formFactura"
                autocomplete="off"
                class="mt-16"
            >
                <mat-form-field class="full-width">
                    <mat-label>Rango de la consulta</mat-label>
                    <mat-date-range-input
                        [formGroup]="rango"
                        [rangePicker]="picker"
                    >
                        <input
                            matStartDate
                            formControlName="inicio"
                            placeholder="Fecha de inicio"
                            readonly
                            required
                        />
                        <input
                            matEndDate
                            formControlName="termino"
                            placeholder="Fecha de término"
                            readonly
                            required
                        />
                    </mat-date-range-input>
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>

                    <mat-error *ngIf="inicio.hasError('matStartDateInvalid')"
                        >Fecha de inicio inválida</mat-error
                    >
                    <mat-error *ngIf="termino.hasError('matEndDateInvalid')"
                        >Fecha de término inválida</mat-error
                    >
                </mat-form-field>

                <mat-form-field class="full-width" *ngIf="esSupervisor">
                    <mat-label>Clientes</mat-label>
                    <mat-select formControlName="clientes" multiple>
                        <mat-option
                            *ngFor="let cliente of listaClientes"
                            [value]="cliente"
                            >{{ cliente.nombre }}</mat-option
                        >
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="full-width" *ngIf="!esSupervisor">
                    <mat-label>Sucursales</mat-label>
                    <mat-select formControlName="sucursales" multiple>
                        <mat-option
                            *ngFor="let sucursal of listaSucursales"
                            [value]="sucursal"
                            >{{ sucursal.nombre }}</mat-option
                        >
                    </mat-select>
                </mat-form-field>
            </form>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            (click)="guardar()"
            [disabled]="!formFactura.valid || (procesando)"
        >
            Descargar
        </button>
    </mat-dialog-actions>
</div>
